import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["text", "variant"];
import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
var TagMenu = function TagMenu(_ref) {
  var text = _ref.text,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(S.Tag, _extends({
    variant: variant
  }, rest), text);
};
TagMenu.defaultProps = {
  variant: 'primary'
};
process.env.NODE_ENV !== "production" ? TagMenu.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string
} : void 0;
export default TagMenu;